export default __webpack_public_path__ + "static/media/shape-icon.5ae19bdb.svg";